import React, { useState } from "react";
import { Loader2, Play, ToggleLeft, ToggleRight } from "lucide-react";
import { toast } from "sonner";
import { tahkimMerkez } from "../lib/tahkimApi";

const MOD_STYLES = {
    OTOMATIK: "border-emerald-500/35 bg-emerald-500/10 text-emerald-200",
    MANUEL: "border-amber-500/35 bg-amber-500/10 text-amber-200",
};

const SEVIYE_STYLES = {
    action: "text-amber-200",
    auto: "text-sky-200",
    warn: "text-rose-200",
    ok: "text-emerald-300/90",
    info: "text-slate-400",
};

export default function SigortaTahkimGecisHucre({ row, onRefresh }) {
    const [busy, setBusy] = useState(false);
    const mod = (row.on_tahkim_gecis_modu || "OTOMATIK").toUpperCase();
    const dd = (row.dosya_durumu || "").toUpperCase();
    const sure = (row.on_tahkim_sure_durumu || "").toUpperCase();
    const seviye = row.gecis_seviye || "info";
    const metin = row.gecis_metin || row.on_tahkim_sure_durumu_etiket || "—";
    const stk = row.stk_uyari;

    async function toggleMod() {
        const next = mod === "OTOMATIK" ? "MANUEL" : "OTOMATIK";
        setBusy(true);
        try {
            await tahkimMerkez.onTahkimGecisModu({
                sigorta_dosya_id: row.id,
                on_tahkim_gecis_modu: next,
            });
            toast.success(next === "OTOMATIK" ? "Otomatik geçiş açıldı" : "Manuel onay modu");
            onRefresh?.();
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Mod güncellenemedi");
        } finally {
            setBusy(false);
        }
    }

    async function onTahkimGecir() {
        setBusy(true);
        try {
            await tahkimMerkez.onTahkimUygula({
                sigorta_dosya_id: row.id,
                whatsapp: true,
            });
            toast.success("Ön tahkime geçirildi");
            onRefresh?.();
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Geçiş yapılamadı");
        } finally {
            setBusy(false);
        }
    }

    const showOnTahkimBtn =
        dd === "BASVURU" &&
        (sure === "HAZIR" || sure === "GECIKTI") &&
        (mod === "MANUEL" || row.gecis_aksiyon === "onay_bekliyor");

    return (
        <div className="min-w-[9rem] max-w-[14rem] space-y-1">
            <div className="flex items-center gap-1 flex-wrap">
                <button
                    type="button"
                    disabled={busy || dd === "KAPATILDI"}
                    onClick={toggleMod}
                    title="Geçiş modunu değiştir"
                    className={`inline-flex items-center gap-0.5 rounded-full border px-1.5 py-0.5 text-[9px] font-medium disabled:opacity-50 ${MOD_STYLES[mod] || MOD_STYLES.OTOMATIK}`}
                >
                    {busy ? (
                        <Loader2 className="h-3 w-3 animate-spin" />
                    ) : mod === "OTOMATIK" ? (
                        <ToggleRight className="h-3 w-3" />
                    ) : (
                        <ToggleLeft className="h-3 w-3" />
                    )}
                    {row.on_tahkim_gecis_modu_etiket || (mod === "OTOMATIK" ? "Otomatik" : "Manuel")}
                </button>
                {row.on_tahkim_sure_durumu_etiket ? (
                    <span className="text-[9px] text-slate-500 truncate">
                        {row.on_tahkim_sure_durumu_etiket}
                    </span>
                ) : null}
            </div>
            <div
                className={`text-[10px] leading-snug line-clamp-2 ${SEVIYE_STYLES[seviye] || SEVIYE_STYLES.info}`}
                title={metin}
            >
                {metin}
            </div>
            {row.on_tahkim_hedef_tarihi ? (
                <div className="text-[9px] text-slate-500 font-mono">
                    Hedef: {String(row.on_tahkim_hedef_tarihi).slice(0, 10).split("-").reverse().join(".")}
                    {row.basvuru_bekleme_gun ? ` · ${row.basvuru_bekleme_gun}g` : ""}
                </div>
            ) : null}
            {showOnTahkimBtn ? (
                <button
                    type="button"
                    disabled={busy}
                    onClick={onTahkimGecir}
                    className="inline-flex items-center gap-0.5 rounded border border-[#D4AF37]/40 bg-[#D4AF37]/15 px-1.5 py-0.5 text-[9px] font-semibold text-[#F3E5AB] hover:bg-[#D4AF37]/25 disabled:opacity-50"
                >
                    {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Play className="h-3 w-3" />}
                    Ön tahkime geçir
                </button>
            ) : null}
            {dd === "ON_TAHKIM" && stk ? (
                <div
                    className={`text-[9px] leading-snug line-clamp-2 ${row.stk_hazir ? "text-violet-200" : "text-rose-200/90"}`}
                    title={stk}
                >
                    STK: {stk}
                </div>
            ) : null}
        </div>
    );
}
